import React from 'react';
import { ResultsTable } from '../../../../DTCustomerAccountView.styles';
import { ResultsHeaderColumn, ResultsHeaderRow, Results } from './SearchResultsLayout.styles';
import DTCustomerSearchResultsList from '../DTCustomerSearchResultsList/DTCustomerSearchResultsList';

export const SearchResultsLayout = () => {
  return (
    <Results key={'orderResults'}>
      <ResultsTable>
        <ResultsHeaderRow>
          <ResultsHeaderColumn>Name</ResultsHeaderColumn>
          <ResultsHeaderColumn>Email</ResultsHeaderColumn>
        </ResultsHeaderRow>
        <DTCustomerSearchResultsList />
      </ResultsTable>
    </Results>
  );
};
